import type { ProjectProgressSnapshot } from '../contracts/types'

export const PROGRESS_ORBIS: ProjectProgressSnapshot = {
  projectId: 'orbis',
  projectName: 'ORBIS',
  projectType: 'film_xr_expandable',
  arcHeadline: 'structure → timeline → presentation → Scape → XR',
  currentFocusStageId: 'structure_coherent',
  summary: {
    readyCount: 4,
    totalCountable: 8,
    headline: 'Story structure coherent — in progress',
  },
  spine: [
    { stageId: 'signal_captured', status: 'ready', label: 'Signal Captured', ordinal: 1, primarySurface: 'guided_studio' },
    { stageId: 'intent_framed', status: 'ready', label: 'Story Framed', ordinal: 2, primarySurface: 'guided_studio' },
    { stageId: 'world_or_scape_defined', status: 'ready', label: 'World Defined', ordinal: 3, primarySurface: 'guided_studio' },
    { stageId: 'character_grounded', status: 'ready', label: 'Characters Grounded', ordinal: 4, primarySurface: 'guided_studio' },
    {
      stageId: 'structure_coherent',
      status: 'in_progress',
      label: 'Story Structure Coherent',
      ordinal: 5,
      primarySurface: 'guided_studio',
    },
    { stageId: 'scene_or_sequence_ready', status: 'future', label: 'Scenes Ready', ordinal: 6, primarySurface: 'guided_studio' },
    { stageId: 'timeline_ready', status: 'future', label: 'Timeline Ready', ordinal: 7, primarySurface: 'omnistudio' },
    { stageId: 'omnistudio_handoff_ready', status: 'future', label: 'OmniStudio Handoff Ready', ordinal: 8, primarySurface: 'omnistudio' },
    { stageId: 'omnicine_timeline_ready', status: 'future', label: 'OmniCine Timeline Ready', ordinal: 9, primarySurface: 'omnicine' },
    {
      stageId: 'omnicast_presentation_ready',
      status: 'future',
      label: 'Screening / Presentation Ready',
      ordinal: 10,
      primarySurface: 'omnicast',
    },
    { stageId: 'scape_world_ready', status: 'future', label: 'Scape / World Ready', ordinal: 11, primarySurface: 'scapes_worlds' },
    { stageId: 'xr_expansion_ready', status: 'future', label: 'XR Extension Ready', ordinal: 12, primarySurface: 'xr_worlds' },
  ],
  parallelGates: [
    {
      stageId: 'rights_passport_pending',
      status: 'needs_review',
      label: 'Rights Passport Pending',
      primarySurface: 'rights_passport',
    },
  ],
  markers: [
    { markerId: 'structure_coherence', label: 'Structure Coherence', state: 'partial' },
    { markerId: 'rights_clearance', label: 'Rights Clearance', state: 'unmet' },
    { markerId: 'presentation_policy', label: 'Presentation Policy', state: 'unmet' },
    { markerId: 'scape_graph', label: 'Scape Graph', state: 'partial' },
    { markerId: 'omnistudio_handoff_approved', label: 'OmniStudio Handoff Approved', state: 'unmet' },
  ],
}
